import { getCustomDuration } from './get_custom_duration'

export const getDurationFromValues = (values) => (
  values.eventDuration === 'custom'
    ? getCustomDuration(values.customEventDuration, values.customEventDurationType)
    : parseInt(values.eventDuration, 10)
)

export const formatValuesToServerData = (values) => ({
  duration: getDurationFromValues(values),
  duration_options: values.durationOptions
})
